"use strict";

function ajaxCallSkill(url, elem) {
  $.ajax({
    method: 'GET',
    url: url,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    success: function success(data) {
      showResultsSkills(elem);
      showSkills(data.results, elem);
      addSkill(elem); // replaceSkillValue(elem);
    },
    error: function error(err) {
      console.log(err);
    }
  });
}

function showResultsSkills(elem) {
  var results = $(elem).next();
  console.log($(elem).next());
  results.addClass('is-open');
  results.empty();
  $window.on('click', function () {
    results.removeClass('is-open');
  });
  results.click(function (event) {
    event.stopPropagation();
  });
}

function showSkills(skills, element) {
  var results = $(element).next();

  for (var i = 0; i < skills.length; i++) {
    var title = skills[i].name,
        id = skills[i].id;
    var res = '<li class="js-skill-value" data-id="' + id + '" data-name="' + title + '">' + '<div>' + '<p>' + title + '</p>' + '</div>' + '</li>';
    results.append(res);
  }
}

function addSkill(element) {
  var items = $('.js-skill-value'),
      menu = $('.js-skill-list');
  items.on('click', function () {
    var value = $(this).data('name');
    $(element).val(value);
    var urlApi = '/api/v1/competences/' + $(this).data('id');
    $.ajax({
      method: 'GET',
      url: urlApi,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      success: function success(data) {
        renderSkill(data);
      },
      error: function error(err) {
        console.log(err);
      }
    });
    menu.empty();
    menu.removeClass('is-open');
  });
}

function renderSkill(skill) {
  var div_skill = '<div class="skills js-skill-block">' + '<div class="close js-close">' + '<img src="/static/svg/private/close-icon.svg" title="Delete">' + '</div>' + '<div class="Input__checkbox checkbox-head">' + '<label>' + '<input class="js-skill-checkbox" type="checkbox" name="' + skill.id + '" value="' + skill.id + '" id="' + skill.id + '" checked>' + '<span></span>' + skill.name + '</label>' + '<a href="javascript:void(0)" class="js-skill-show">' + '<img class="skill-arrow" src="' + arrowImg + '" />' + '</a>' + '</div>' + '<div class="content">';

  for (var i = 0; i < skill.problematics_obj.length; i++) {
    var name = skill.problematics_obj[i].name,
        id = skill.problematics_obj[i].id;
    div_skill += '<div class="Input__checkbox" v-for="problematic in competence.problematics_obj">' + '<label>' + '<input class="js-problematic" type="checkbox" name="' + name + '" value="' + id + '" id="' + id + '" checked>' + '<span></span>' + name + '</label>' + '</div>';
  }

  div_skill += '</div></div>';
  $('.js-skills-wrapper').prepend(div_skill);
  $('.js-skill-block').closeSkill();
  $('.js-skill-checkbox').skillCheckboxes();
  $('.js-skill-show').toggleSkill();
}

function inputSkill() {
  var elem = document.getElementById('add_skills');
  var timeout = null;

  elem.onkeyup = function (e) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      ajaxCallSkill('/api/v1/competences?competence=' + elem.value, elem);
    }, 500);
  };
}